module.exports = __webpack_public_path__ + "img/drug-6.9d0a0a70.png";